import { HEADER_VIDEO } from "../action/types";

export const setHeadVideoLoaded = (data) => (dispatch) => {
    dispatch({
        type: HEADER_VIDEO,
        payload: {doneHeaderVideo: data.doneHeaderVideo, headerVideoName: data.headerVideoName}
    })
};
